export default __webpack_public_path__ + "static/media/signal-0.4e2595f7.svg";